module.exports = "/_next/static/images/english-526d147605061a058eaea6b67701fd0a.png";